import { render, staticRenderFns } from "./TablePaginator.vue?vue&type=template&id=5aaf32d8"
import script from "./TablePaginator.vue?vue&type=script&lang=js"
export * from "./TablePaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aaf32d8')) {
      api.createRecord('5aaf32d8', component.options)
    } else {
      api.reload('5aaf32d8', component.options)
    }
    module.hot.accept("./TablePaginator.vue?vue&type=template&id=5aaf32d8", function () {
      api.rerender('5aaf32d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/TablePaginator.vue"
export default component.exports